<template>
  <div>
    <div v-if="$route.path.indexOf('_detail') === -1">
      <el-row :gutter="10">
        <el-col :md="6" :lg="5">
          <el-input placeholder="手机号" v-model="mobile" clearable size="mini">
            <el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="6" :lg="5">
          <el-input placeholder="会员id" v-model="offline_card_id" clearable size="mini">
            <el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="6" :lg="5">
          <el-input placeholder="来源" v-model="source_from" clearable size="mini">
            <el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="6" :lg="4">
          <el-select v-model="order_records" @change="ifHaveOrderRecords" placeholder="有无购买记录" clearable
            style="width: 100%;" size="mini">
            <el-option label="有记录" value="true"></el-option>
            <el-option label="无记录" value="false"></el-option>
          </el-select>
        </el-col>

        <el-col :md="2" :lg="4">
          <el-button style="float: right; padding: 3px 0" type="text" @click="panelCollapse('search')">
            <span v-if="panel.search">点击收缩更多操作</span>
            <span v-else>点击展开更多操作</span>
            <i class="iconfont" :class="panel.search ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
          </el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-show="panel.search">
        <el-col :md="4" :lg="4">
          <el-select v-model="params.tag_id" placeholder="请选择标签" @change="tagSearchUserChange" clearable
            style="width: 100%;" size="mini">
            <el-option v-for="item in tag.list" :key="item.tag_id" :label="item.tag_name" :value="item.tag_id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="4" :lg="4">
          <el-select v-model="params.vip99_flag" placeholder="是否付费会员" @change="isvip99Flag" clearable style="width: 100%;"
            size="mini">
            <el-option label="付费会员" value="true"></el-option>
            <el-option label="全部会员" value=""></el-option>
          </el-select>
        </el-col>
        <el-col :md="6" :lg="6">
          <el-input placeholder="推荐人手机号" v-model="inviter_mobile" clearable size="mini">
            <el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="9" :lg="9">
          <el-date-picker v-model="created" type="daterange" align="right" unlink-panels range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="dateChange"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd" size="mini">
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="30" v-show="panel.search">
        <el-col :md="6" :lg="6">
          <el-input placeholder="备注" v-model="params.remarks" clearable size="mini">
            <el-button slot="append" icon="el-icon-search" @click="remarksSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :md="6" :lg="6">
          <el-input placeholder="姓名" v-model="params.username" clearable size="mini">
            <el-button slot="append" icon="el-icon-search" @click="remarksSearch"></el-button>
          </el-input>
        </el-col>
        <!-- <el-col :md="5" :lg="5">
          <el-input placeholder="导购员手机号" v-model="salesman_mobile" clearable size="mini">
            <el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button>
          </el-input>
        </el-col> -->
      </el-row>
      <!-- <el-row :gutter="30" v-show="panel.search">
        <el-col :md="8" :lg="6">
          <el-select v-model="currentShop" @change="shopHandle" clearable placeholder="请选择门店" style="width: 100%;"
            size="mini">
            <el-option v-for="item in wxShopsList" :key="item.wxShopId" :label="item.storeName" :value="item.wxShopId">
            </el-option>
          </el-select>
        </el-col>
        <el-col :md="12" :lg="12">
          <shop-select v-if="$store.getters.login_type != 'distributor'" distributors :performInit='performInit'
            @update="storeHandle" @init="init"></shop-select>
        </el-col>
      </el-row> -->
      <el-row :gutter="30" v-show="panel.search">
        <!-- 练习测试使用 -->
        <el-col :md="10" :lg="12">
          <el-input :rows="2" placeholder="手机号群发，多个手机号使用回车换行" type='textarea' v-model="mobiles" clearable size="mini">
          </el-input>
        </el-col>
        <el-col :md="10" :lg="12">
          <el-button size="mini" type="primary" icon="plus" @click="Serachmobiles">确定</el-button>
        </el-col>
        <!-- END -->
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-button-group>
            <el-button size="mini" type="primary" icon="plus" @click="addMemberTag">打标签</el-button>
            <el-button size="mini" type="primary" icon="plus" @click="addResource">赠送优惠券</el-button>
            <el-button size="mini" type="primary" icon="plus" @click="smsSends">群发短信</el-button>
            <!-- <el-button size="mini" type="primary" icon="plus" @click="handleVipGradeDelay(false)">付费会员延期</el-button> -->
            <el-button size="mini" type="primary" icon="plus" @click="delUserWxappInfo()">用户撤销授权</el-button>
            <el-button v-if="is_distributor" size="mini" type="primary" icon="plus" @click="setSalesman(false)">设置导购员</el-button>
            <!--<el-button size="mini" type="primary" icon="plus" @click="batchGradeUpdate">会员等级设置</el-button>-->
          </el-button-group>
          <el-button size="mini" type="primary" @click="exportData">导出</el-button>
          <el-popover placement="top-start" width="200" trigger="hover" content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
          <el-button size="mini" type="primary" @click="exportLogData">预存款记录导出</el-button>
        </el-col>
      </el-row>
      <el-dialog title="日志导出" :visible.sync="exportdialogFormVisible">
      <el-form :model="logform">
        <el-date-picker
          v-model="logform.times"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <el-button @click="exportLog()">确认导出</el-button>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportdialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="exportdialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量删除用户授权" :visible.sync="batchDelDialog" :before-close="handleCancelBatchDelDialog">
      <el-form label-width="210px">
        <el-form-item class="content-center" label="用户 open_id">
          <el-row>
            <el-col :md="16" :lg="16">
              <el-input :rows="3" placeholder="多个 openID 使用回车符换行" type='textarea' v-model="openIDs" clearable size="mini"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDelDialog = false">取 消</el-button>
        <el-button type="primary" @click="batchDelUserWxappInfo">确 定</el-button>
      </div>
    </el-dialog>
      <el-dialog title="会员下载" :visible.sync="downloadView" :close-on-click-modal="false">
        <template v-if="downloadUrl">
          <a :href="downloadUrl" download>{{ downloadName }}</a>
        </template>
      </el-dialog>
      <el-table :data="memberData" :row-key="getRowKeys" :height="wheight - 210" @selection-change="handleSelectionChange"
        v-loading="loading" ref="multipleTable" tooltip-effect="dark">
        <el-table-column type="selection" :reserve-selection="true" v-model="checked" align="center"
          label="全选"></el-table-column>
        <el-table-column prop="user_card_code" v-if="false" label="会员卡编号" width="130"></el-table-column>
        <el-table-column label="ID" width="130">
          <template slot-scope="scope">
            {{ scope.row.user_id}}
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号" width="136">
          <template slot-scope="scope">
            {{ scope.row.mobile }}
            <i class="iconfont icon-pencil-alt mobile-editor" @click="editMobile(scope.row)"></i>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="姓名" width="100">
          <template slot-scope="scope">
            {{ scope.row.username }}
            <i class="iconfont icon-pencil-alt mobile-editor" @click="editUsername(scope.row)"></i>
          </template>
        </el-table-column>
        <el-table-column prop="sex" label="性别" width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.sex == '2'">女</span>
            <span v-else-if="scope.row.sex == '1'">男</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column prop="flag" label="是否实名" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.flag == '0'" type="error">未实名</el-tag>
            <el-tag v-else-if="scope.row.flag == '1'" type="success">已实名</el-tag>
            <el-tag v-else>未实名</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="realname" label="真实姓名" width="120"></el-table-column>
        <!--<el-table-column prop="connact_mobile" label="联系方式" width="120"></el-table-column>-->
        <el-table-column prop="offline_card_id" label="中台会员id" width="120"></el-table-column>
        <el-table-column prop="inviter" label="推荐人" width="120"></el-table-column>
        <el-table-column prop="created" label="注册日期" width="120">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">注册时间<br />{{ scope.row.created | datetime('yyyy-MM-dd hh:mm:ss') }}</div>
              <span>{{ scope.row.created | datetime }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="source_from" label="来源" width="80"></el-table-column>
        <el-table-column prop="disabled" label="是否禁用" width="80">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.disabled" active-value="1" inactive-value="0"
              @change="acitonDisabled(scope.$index, scope.row)" active-color="#ff4949" inactive-color="#13ce66"></>
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="备注" width="160">
          <template slot-scope="scope">
            {{ scope.row.remarks }}
            <i class="iconfont icon-pencil-alt mobile-editor" @click="isEdit(scope.row)"></i>
          </template>
        </el-table-column>
        <el-table-column prop="tagList" label="标签" width="160">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.vip99" color="#d81e06" :style="'color:#ffffff'">付费会员</el-tag>
            <el-tag v-for="taglist in scope.row.tagList" :key="taglist.index" :color="taglist.tag_color" size="mini"
              :style="'color:' + taglist.font_color" style="display: inline-block; margin-right:3px;">{{ taglist.tag_name
              }}</el-tag>
          </template>

        </el-table-column>
        <el-table-column label="操作" width="380">
          <template slot-scope="scope">
            <el-button type="text" @click="getDetail(scope.row.user_id)">详情</el-button>
            <el-button type="text" @click="tagUpdate(scope.row)">标签</el-button>
            <!--<el-button type="text" @click="gradeUpdate(scope.row)">编辑会员等级</el-button>-->
            <el-button type="text" @click="updateOfflineCode(scope.row)">更新线下卡</el-button>
            <el-button type="text" @click="editPassword(scope.row)">重置登录密码</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-checkbox v-model="allCheck" @change="allCheckEvent">全选所有</el-checkbox>
      <span>(注：只支持群发优惠券和群发短息)</span>
      <div v-if="total_count > params.pageSize" class="content-padded tc">
        <el-pagination background layout="prev, pager, next, total" @current-change="handleCurrentChange"
          :current-page.sync="params.page" :total='total_count' :page-size='params.pageSize'>
        </el-pagination>
      </div>
      <el-dialog title="赠送优惠券" class="right-dialog" :visible.sync="addCouponsDialog"
        :before-close="handleCancelLabelsDialog">
        <template>
          <el-form>
            <el-form-item label-width="100px" label="搜索优惠券">
              <el-input v-model="couponsParams.title" type="text" placeholder="搜索优惠券">
                <el-button slot="append" icon="el-icon-search" @click="searchCoupons"></el-button>
              </el-input>
            </el-form-item>
            <el-form-item label-width="100px" label="选择优惠券">
              <el-transfer v-model="addCouponsItems" :titles="['优惠券列表', '已选中']" :data="couponsList">
                <div class="transfer-footer" slot="left-footer">
                  <el-pagination v-if="coupons_total_count > couponsParams.page_size" small layout="prev, pager, next"
                    @current-change="handleCouponsChange" :total="coupons_total_count"
                    :page-size="couponsParams.page_size">
                  </el-pagination>
                </div>
                <div class="transfer-footer" slot="right-footer"></div>
              </el-transfer>
            </el-form-item>
            <el-form-item class="content-center">
              <el-button type="primary" @click="onSubmit">确定添加</el-button>
            </el-form-item>
          </el-form>
        </template>
      </el-dialog>
      <el-dialog title="批量修改付费会员延期" :visible.sync="vipGradeDialog" :before-close="handleCancelLabelsDialog">
        <el-form label-width="100px">
          <el-form-item class="content-center" label="付费会员类型">
            <el-row>
              <el-col :span="8">
                <el-select v-model="vipGradeDelay.vip_grade_id" style="width: 100%;">
                  <el-option v-for="item in vipGrade" :key="item.lv_type" :label="item.grade_name"
                    :value="item.vip_grade_id"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item class="content-center" label="延期条件">
            <el-row>
              <el-col :span="8">
                <el-select v-model="vipGradeDelay.filter" style="width: 100%;">
                  <el-option key="users" label="已选择会员" value="users"></el-option>
                  <el-option key="expired" label="付费会员已失效" value="expired"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item v-if="vipGradeDelay.filter == 'users'" class="content-left">

            <span v-if="smsForm.mobile.length > 0">
              <el-alert title="" type="success" :closable="false"><span v-for="item in smsForm.mobile"> {{ item }}、</span>
              </el-alert>
              <span>共：{{ smsForm.mobile.length }}</span>
            </span>

            <span v-else>请先选择会员</span>
          </el-form-item>
          <el-form-item class="content-center" label="延期天数">
            <el-row>
              <el-col :span="8">
                <el-input v-model="vipGradeDelay.add_day"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button type="primary" @click="handleVipGradeDelay(true)">确定延期</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="批量设置导购员" :visible.sync="setSalesmanDialog" :before-close="handleCancelLabelsDialog">
        <el-form label-width="100px">
          <el-form-item class="content-center" label="选择导购员">
            <el-row>
              <el-col :span="8">
                <el-select v-model="salesman_id" style="width: 100%;">
                  <el-option v-for="item in salesman" :key="item.salesman_id" :label="item.salesman_name"
                    :value="item.salesman_id"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button type="primary" @click="setSalesman(true)">确定</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="编辑会员等级" :visible.sync="updateGradeDialog" :before-close="handleCancelLabelsDialog">
        <el-form label-width="100px">
          <el-form-item class="content-center" label="会员等级">
            <el-row>
              <el-col :span="8">
                <el-select v-model="gradeForm.grade_id" style="width: 100%;">
                  <el-option v-for="item in levelData" :key="item.grade_id" :label="item.grade_name"
                    :value="item.grade_id"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item class="content-center" label="备注">
            <el-row>
              <el-col :span="20">
                <el-input focus type="textarea" :rows="3" v-model="gradeForm.remarks"></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button type="primary" @click="gradeUpdateSubmit">确定修改</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="更新线下会员卡【确认会员卡信息有误或者没有同步到np再做更新】" :visible.sync="updateOfflineCodeDialog"
        :before-close="handleCancelLabelsDialog">
        <el-form label-width="100px">
          <el-form-item class="content-center" label="姓名">
            <el-input v-model="gradeForm.username" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item class="content-center" label="手机号">
            <el-input v-model="gradeForm.mobile" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item class="content-center" label="线下会员卡ID">
            <el-input v-model="gradeForm.offline_card_id" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item class="content-center" label="线下会员卡号">
            <el-input v-model="gradeForm.offline_card_code" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item class="content-center">
            <el-button type="primary" @click="pushMemberCenter">推送会员中台</el-button>
            <!-- <el-button type="primary" @click="updateOfflineCodeSubmit">确定更新</el-button> -->
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="群发短信" class="right-dialog" :visible.sync="smsSeedsDialog"
        :before-close="handleCancelLabelsDialog">
        <template>
          <el-form>
            <el-form-item class="content-left">
              <span v-if="overall == 0">
                <el-alert title="" type="success" :closable="false"><span v-for="item in smsForm.mobile"> {{ item
                }}、</span>
                </el-alert>
                <span>共：{{ smsForm.mobile.length }}</span>
              </span>
              <span v-else>
                <el-alert title="" type="success" :closable="false"><span>您已选择全部用户</span> </el-alert>
                <span>共：{{ total_count }}</span>
              </span>
            </el-form-item>
            <el-form-item class="content-center">
              <el-input focus type="textarea" :rows="4" placeholder="请输入短信内容" v-model="smsForm.sms_content"
                @blur="checkNum"></el-input>
              <span>{{ smsForm.sms_content.length }}</span>
            </el-form-item>
            <el-form-item class="content-center">
              <el-button type="primary" @click="onSmsSends">确定发送</el-button>
            </el-form-item>
          </el-form>
          <template>
            <el-alert title="短信基础" type="info" description="1、短信字符<=67个字符，按照70个字符一条短信计算；短信内容中，汉字、字母、符号、数字、空格全按一个字符算，不分半角、全角。含有标签（如短信签名、商品名、链接）的短信以实际发送时字符数计算；超过规定的67个字符的短信内容将会被拆分为两条或多条短信
                            2、短信内容禁止有‘测试，test，错乱字符’等，这类短信会被拦截不予发送。
                            3、短信接收不到原因：手机号黑名单发送不了；内容不正规不允发送；时间段导致延迟；被手机拦截软件拦截；该手机号短信接收上限；该手机号状态不正常（欠费，停机，空号，信号不正常）详询客服
                            4、 短信内容切记出现敏感类字眼，如出现有的话，系统是发送不出去被拦截掉的哦。
                            5、 短信内容当中不允许出现两个【】或 ⎣⎤ 括弧">
            </el-alert>
            <el-alert title="营销短信（手动输入的短信）" type="info" description="营销短信发送时间为8：00~21:00，双十一双十二大促期间，短信发送时间可24小时。">
            </el-alert>
            <el-alert title="短信限制注意事项" type="info" description="1、通知短信加营销短信同一号码月限制50条。2、相同内容，相同手机号，日限制2条，第3条会被拦截。">
            </el-alert>
          </template>
        </template>
      </el-dialog>
      <el-dialog title="为会员打标签" class="right-dialog" :visible.sync="tag.dialog" :before-close="handleCancelLabelsDialog">
        <div class="tag-users view-flex view-flex-middle">
          <i class="iconfont icon-user-circle1"></i>
          <div class="view-flex-item">
            <span v-for="item in tag.editUser"> {{ item }}，</span>
          </div>
        </div>
        <div class="selected-tags view-flex">
          <div class="label">已选中标签：</div>
          <div class="view-flex-item">
            <el-tag :key="index" v-for="(tag, index) in tag.currentTags" closable size="small"
              :disable-transitions="false" @close="tagRemove(index)">
              {{ tag.tag_name }}
            </el-tag>
          </div>
        </div>
        <div>
          <el-tag class="tag-item" :key="index" v-for="(tag, index) in tag.tags" size="medium" color="#ffffff"
            :disable-transitions="false" @click.native="tagAdd(tag, index)">
            {{ tag.tag_name }}
          </el-tag>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="tag.dialog = false">取 消</el-button>
          <el-button type="primary" @click="submitMemberTag">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="修改会员手机号" class="right-dialog" :visible.sync="editMobileDialog"
        :before-close="handleCancelLabelsDialog">
        <template>
          <el-form>
            <el-form-item label-width="100px" label="会员名称">
              {{ form.username }}
            </el-form-item>
            <el-form-item label-width="100px" label="原手机号">
              {{ form.oldMobile }}
            </el-form-item>
            <el-form-item label-width="100px" label="新手机号">
              <el-input v-model="form.newMobile" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item class="content-center">
              <el-button type="primary" @click="onEditMobileSubmit">确定添加</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template>
          <el-table :data="operateLog" height="580" border v-loading="loading">
            <el-table-column prop="old_data" label="原手机号"></el-table-column>
            <el-table-column prop="new_data" label="修改后手机号"></el-table-column>
            <el-table-column prop="operater" label="操作员"></el-table-column>
            <el-table-column prop="created" label="操作时间"></el-table-column>
          </el-table>
        </template>
      </el-dialog>
      <el-dialog title="修改会员备注" class="right-dialog" :visible.sync="isEditRemarks"
        :before-close="handleCancelLabelsDialog">
        <template>
          <el-form>
            <el-form-item label-width="100px" label="备注">
              <el-input v-model="remarksForm.remarks" placeholder="输入备注"></el-input>
            </el-form-item>
            <el-form-item class="content-center">
              <el-button type="primary" @click="editRemarks()">确定</el-button>
            </el-form-item>
          </el-form>
        </template>

      </el-dialog>
      <el-dialog title="修改会员姓名" class="right-dialog" :visible.sync="editUsernameDialog"
        :before-close="handleCancelLabelsDialog">
        <template>
          <el-form>
            <el-form-item label-width="100px" label="会员id">
              {{ updateUserForm.user_id }}
            </el-form-item>
            <el-form-item label-width="100px" label="手机号">
              {{ updateUserForm.mobile }}
            </el-form-item>
            <el-form-item label-width="100px" label="会员名称">
              <el-input v-model="updateUserForm.username" placeholder="会员名称"></el-input>
            </el-form-item>
            <el-form-item class="content-center">
              <el-button type="primary" @click="editUsernameSubmit()">确定</el-button>
            </el-form-item>
          </el-form>
        </template>

      </el-dialog>

      <el-dialog title="重置会员密码" class="right-dialog" :visible.sync="editPasswordDialog"
        :before-close="handleCancelLabelsDialog">
        <template>
          <el-form>
            <el-form-item label-width="100px" label="手机号">
              {{ editpassForm.mobile }}
            </el-form-item>
            <el-form-item label-width="100px" label="密码">
              <el-input v-model="editpassForm.password" placeholder="密码"></el-input>
            </el-form-item>
            <el-form-item class="content-center">
              <el-button type="primary" @click="editPassSubmit()">确定</el-button>
            </el-form-item>
          </el-form>
        </template>

      </el-dialog>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import store from '@/store'
import {
  mapGetters
} from 'vuex'
import {
  getTel,
  getMembers,
  getMobiles,
  memberSmsSend,
  getTagList,
  usersRelTags,
  tagSearchUser,
  updateMemberMobile,
  getMemberOperateLog,
  memberExport,
  updateMemberInfo,
  setMemberSalesman,
  updateMemberGrade,
  batchupdateMemberGrade,
  updateMemberOffline,
  advancelogExport,
  resetMemberPassword,
  pushMemberCenter,
  batchDelUserInfo,
} from '../../../api/member'
import {
  getGradeList
} from '../../../api/membercard'
import {
  getSalesmanList
} from '../../../api/marketing'
import {
  getEffectiveCardList
} from '../../../api/cardticket'
import {
  giveCoupons
} from '../../../api/promotions'
import {
  listVipGrade,
  batchReceiveMemberCard
} from '../../../api/cardticket'
import {
  getWxShopsList
} from '../../../api/shop'
import shopSelect from '@/components/shopSelect'

export default {
  components: {
    shopSelect
  },

  data() {
    return {
      openIDs: null,
      exportdialogFormVisible:false,
      logform:{
        times:''
      },
      panel: {
        search: false
      },
      allDataFlag: false,
      inviter_mobile: '',
      is_distributor: false,
      salesman_mobile: '',

      /***练习测试***/
      mobiles: '',
      offline_card_id:'',
      offline_card_code: '',
      source_from: '',
      tel: [],
      options4: [],
      listNew: [],
      loading: false,
      states: [],
      /***END***/
      isEditRemarks: false,
      addCouponsDialog: false,
      couponsList: [],
      addCouponsItems: [],
      couponsListSelect: [],
      loading: false,
      mobile: '',
      checked: '',
      value: [],
      allCheck: '',
      user_id: [],
      /***练习测试***/
      // getRowKeys(row) {
      //    return row.user_id;
      // },
      overall: 0,
      /****END***/
      total_count: 0,
      memberData: [],
      order_records: '',
      vipGradeDelay: {
        vip_grade_id: "",
        add_day: 0,
        filter: 'users'
      },
      vipGradeDelayUsers: [],
      levelData: [],
      grade_id: '',

      coupons_total_count: 0,
      coupons_page: 1,
      couponsParams: {
        title: '',
        page_no: 1,
        page_size: 10
      },
      smsSeedsDialog: false,
      vipGradeDialog: false,
      setSalesmanDialog: false,
      updateGradeDialog: false,
      updateOfflineCodeDialog: false,
      editUsernameDialog: false,
      editPasswordDialog:false,
      editpassForm:{
        mobile:'',
        password:''
      },
      smsForm: {
        overall: 0,
        where: [],
        mobile: [],
        sms_content: ''
      },
      remarksForm: {
        user_id: '',
        remarks: ''
      },
      gradeForm: {
        user_id: '',
        grade_id: '',
        old_grade_id: '',
        remarks: ''
      },
      updateUserForm: {
        user_id: '',
        mobile: '',
        username: ''
      },
      smsUserData: [],
      sms_content: '',
      tag: {
        dialog: false,
        editUser: [],
        list: [],
        form: {
          tag_ids: [],
          user_ids: []
        },
        currentTags: [],
        tags: []
      },
      editMobileDialog: false,
      batchDelDialog: false,
      form: {
        oldMobile: '',
        user_id: '',
        newMobile: ''
      },
      params: {
        page: 1,
        pageSize: 20,
        vip_grade: '',
        tag_id: '',
        vip99_flag: '',
      },
      operateLog: [],
      currentShop: '',
      vipGrade: [],
      salesman: [],
      salesman_id: '',
      is_batch: false,
      currentDistributor: '',
      downloadView: false,
      downloadUrl: '',
      downloadName: '',
      wxShopsList: [],
      performInit: false,
      created: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },

  methods: {
    delUserWxappInfo () {
      this.batchDelDialog = true
    },
    batchDelUserWxappInfo () {
      console.log(this.openIDs)
      let query = {
        'open_ids': this.openIDs
      }
      batchDelUserInfo(query).then(res => {
        this.$message({
          type: 'success',
          message: res.data.data.message
        })
        this.batchDelDialog = false
      })
    },
    handleCancelBatchDelDialog () {
      this.batchDelDialog = false
    },
    /*******练习测试*******/
    toggleRowSelect(rows) {
      const _this = this
      if (rows.length > 0) {
        this.$nextTick(() => {
          rows.forEach(row => {
            _this.$refs.multipleTable.toggleRowSelection(row, true)
          })
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    allCheckEvent() {
      let _this = this;
      if (_this.allCheck) {

        // 全选选中时当前页所有数据选中
        _this.memberData.forEach(row => {
          this.overall = 1;
          if (row) {
            _this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });

      } else {
        this.overall = 0;
        _this.$refs.multipleTable.clearSelection();
      }
    },

    /********END********/
    updateOfflineCode(row) {
      this.updateOfflineCodeDialog = true
      this.gradeForm.mobile = row.mobile
      this.gradeForm.username = row.username
      this.gradeForm.user_id = row.user_id
      this.gradeForm.offline_card_id = row.offline_card_id
      this.gradeForm.offline_card_code = row.offline_card_code
    },
    updateOfflineCodeSubmit() {
      updateMemberOffline(this.gradeForm).then(res => {
        this.$message({ type: 'success', message: '修改成功' })
        this.updateOfflineCodeDialog = false
        this.getMembers(this.params)
      })
    },
    //推送到会员中台
    pushMemberCenter(){
      pushMemberCenter(this.gradeForm).then(res => {
        this.$message({ type: 'success', message: '更新成功' })
        this.updateOfflineCodeDialog = false
        this.getMembers(this.params)
      })
    },
    // 重置登录密码
    editPassword(row){
      this.editPasswordDialog = true
      this.editpassForm.mobile = row.mobile;
    },
    editPassSubmit(){
      resetMemberPassword({mobile:this.editpassForm.mobile,password:this.editpassForm.password}).then(res => {
        this.$message({ type: 'success', message: '更新成功' })
        this.editPasswordDialog = false
      })
      this.editpassForm.password = '';
    },
    editUsername(row) {
      this.editUsernameDialog = true
      this.updateUserForm.username = row.username
      this.updateUserForm.user_id = row.user_id
      this.updateUserForm.mobile = row.mobile
    },
    editUsernameSubmit() {
      updateMemberInfo({ user_id: this.updateUserForm.user_id, username: this.updateUserForm.username }).then(res => {
        this.$message({ type: 'success', message: '更新成功' })
        this.editUsernameDialog = false
        this.getMembers(this.params)
      })
    },
    gradeUpdate(row) {
      this.updateGradeDialog = true
      this.gradeForm.user_id = row.user_id
      this.gradeForm.grade_id = row.grade_id
      this.gradeForm.old_grade_id = row.grade_id
      this.gradeForm.remarks = ''
    },
    gradeUpdateSubmit() {
      if (this.is_batch === false) {
        updateMemberGrade(this.gradeForm).then(res => {
          this.$message({ type: 'success', message: '修改成功' })
          this.updateGradeDialog = false
          this.getMembers(this.params)
        })
      } else {
        let data = []
        this.user_id.forEach(itemid => {
          data.push({ user_id: itemid })
        })
        let params = {
          'user_ids': JSON.stringify(data),
          'grade_id': this.gradeForm.grade_id,
          'remarks': this.gradeForm.remarks
        }
        batchupdateMemberGrade(params).then(res => {
          this.$message({ type: 'success', message: '修改成功' })
          this.updateGradeDialog = false
          this.is_batch = false
          this.getMembers(this.params)
        })
      }
    },
    batchGradeUpdate() {
      if (this.user_id.length === 0 && this.overall == 0) {

        this.$message({
          type: 'error',
          message: '请选择用户'
        })
        return ''
      }
      this.gradeForm.grade_id = ''
      this.gradeForm.remarks = ''
      this.updateGradeDialog = true
      this.is_batch = true
    },
    editRemarks() {
      updateMemberInfo({ user_id: this.remarksForm.user_id, remarks: this.remarksForm.remarks }).then(res => {
        this.$message({ type: 'success', message: '更新成功' })
        this.isEditRemarks = false
        this.getMembers(this.params)
      })
    },
    isEdit(row) {
      this.isEditRemarks = true
      this.remarksForm.user_id = row.user_id
      this.remarksForm.remarks = row.remarks
    },
    getRowKeys(row) {
      return row.user_id + row.shop_id
    },
    onSubmit() {

      let query = {
        params: this.params,
        overall: this.overall,
        userids: this.user_id,
        couponsids: this.addCouponsItems,
        sender: this.name ? this.name : ''
      }
      if (this.user_id.length == 0 && this.overall == 0) {
        this.$message({
          type: 'error',
          message: '请选择用户'
        })
        return ''
      }
      if (this.addCouponsItems.length == 0) {
        this.$message({
          type: 'error',
          message: '请选择优惠券'
        })
        return ''
      }
      giveCoupons(query).then(res => {
        this.addCouponsItems = []
        this.user_id = []
        this.$message({
          type: 'success',
          message: '赠送优惠券成功'
        })
        this.couponsParams.page_no = 1
        this.getGradeList()
        this.getMembers(this.params)
        this.addCouponsDialog = false
      })
    },
    addResource() {
      if (this.user_id.length || this.overall == 1) {
        this.getCoupons()
        this.addCouponsDialog = true
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个会员之后赠送优惠券!'
        })
      }
    },
    handleCancelLabelsDialog() {
      this.addCouponsDialog = false
      this.smsSeedsDialog = false
      this.vipGradeDialog = false
      this.tag.dialog = false
      this.editMobileDialog = false
      this.setSalesmanDialog = false
      this.isEditRemarks = false
      this.updateGradeDialog = false
      this.updateOfflineCodeDialog = false
      this.editUsernameDialog = false
      this.editPasswordDialog = false
    },
    // 模糊查询优惠券
    searchCoupons() {
      console.log(this.couponsParams)
      this.getCoupons()
    },
    handleCouponsChange(val) {
      this.couponsParams.page_no = val
      this.couponsListSelect = []
      this.couponsList.forEach(row => {
        // 如果选中
        let index = this.addCouponsItems.indexOf(row.key)
        if (index != -1) {
          this.couponsListSelect.push(row)
        }
      })
      this.getCoupons()
    },
    handleSelectionChange(rows) {
      this.user_id = []
      this.smsForm.mobile = []
      console.log('before' + this.smsForm.mobile)
      this.smsUserData = []
      this.vipGradeDelayUsers = []
      if (rows) {
        rows.forEach(row => {
          if (row) {
            this.user_id.push(row.user_id)
            this.smsForm.mobile.push(row.mobile)
            this.smsUserData.push(row.username)
            this.vipGradeDelayUsers.push({
              user_id: row.user_id,
              mobile: row.mobile
            })
          }
        })
      }
      console.log('after' + this.smsForm.mobile)
    },
    handleCurrentChange(val) {
      this.params.page = val
      this.getParams()
      this.getMembers(this.params)
    },
    numberSearch(e) {
      this.params.page = 1
      this.getParams()
      this.getMembers(this.params)

    },

    /****练习测试****/
    Serachmobiles(e) {
      this.params.page = 1
      this.getParams()
      this.getMembers(this.params)
    },

    /******END******/

    remarksSearch(e) {
      this.params.page = 1
      this.getParams()
      this.getMembers(this.params)
    },
    getParams() {
      if (this.mobile) {
        this.params.mobile = this.mobile
      }
      if (this.mobiles) {
        this.params.mobiles = this.mobiles
      }
      if (this.source_from) {
        this.params.source_from = this.source_from
      } else {
        this.params.source_from = '';
      }
      if (this.offline_card_code) {
        this.params.offline_card_code = this.offline_card_code
      }
      if (this.offline_card_id) {
        this.params.offline_card_id = this.offline_card_id
      }
      if (this.inviter_mobile) {
        this.params.inviter_mobile = this.inviter_mobile
      }
      if (this.salesman_mobile) {
        this.params.salesman_mobile = this.salesman_mobile
      }
      if (this.currentShop) {
        this.params.shop_id = this.currentShop
      } else {
        this.params.shop_id = ''
      }
      if (this.currentDistributor) {
        this.params.distributor_id = this.currentDistributor
      } else {
        this.params.distributor_id = ''
      }
    },
    getMembers(filter) {
      this.loading = true
      getMembers(filter).then(response => {
        this.memberData = response.data.data.list
        this.total_count = Number(response.data.data.total_count)
        this.loading = false
        delete this.params.mobile
      })
    },
    getGradeList() {
      getGradeList().then(response => {
        if (response != undefined && response.data.data && response.data.data.length > 0) {
          this.levelData = response.data.data
        }
      })
    },

    getDetail(userid) {
      this.$router.push({
        path: this.matchHidePage('detail'),
        query: {
          user_id: userid,
          mobile: this.mobile,
          orderRecords: this.order_records,
          grade_id: this.params.grade_id,
          currentPage: this.params.page
        }
      })
    },
    getCoupons() {
      getEffectiveCardList(this.couponsParams).then(response => {
        let list = []
        response.data.data.list.forEach(row => {
          let index = -1
          if (this.addCouponsItems) {
            index = this.addCouponsItems.indexOf(row.card_id)
          }
          // 如果未选中
          if (index === -1) {
            list.push({
              key: row.card_id,
              label: row.title + '(' + row.quantity + ')'
            })
          }
        })
        if (this.couponsListSelect) {
          this.couponsList = list.concat(this.couponsListSelect)
        } else {
          this.couponsList = list
        }
        this.coupons_total_count = response.data.data.total_count
      })
    },
    ifHaveOrderRecords(val) {
      this.params.have_consume = val
      this.currentPage = 1
      this.getParams()
      this.getMembers(this.params)
      this.loading = false
    },
    isvip99Flag(val) {
      this.params.vip99_flag = val
      this.currentPage = 1
      this.getParams()
      this.getMembers(this.params)
      this.loading = false
    },
    vipGradeChange(val) {
      this.params.grade_id = ''
      this.params.vip_grade = val
      this.currentPage = 1
      this.getParams()
      this.getMembers(this.params)
      this.loading = false
    },
    ifLevelData(val) {
      this.params.grade_id = val
      this.params.vip_grade = ''

      this.currentPage = 1
      this.getParams()
      this.getMembers(this.params)
      this.loading = false
    },
    smsSends() {
      if (this.smsUserData.length) {
        this.smsSeedsDialog = true
        this.sms_content = ''
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个会员之后发送短信!'
        })
      }
    },
    setSalesman(isSubmit = false) {
      if (this.user_id.length < 1) {
        this.$message({
          type: 'error',
          message: '必须选择的会员'
        })
        return
      }
      if (isSubmit) {
        let params = {
          'user_ids': JSON.stringify(this.user_id),
          'salesman_id': this.salesman_id
        }
        setMemberSalesman(params).then(res => {
          if (res.data.data.status) {
            this.$message({
              type: 'success',
              message: '设置成功'
            })
            this.setSalesmanDialog = false
            this.getMembers(this.params)
          }
        })
      } else {
        getSalesmanList({ page: 1, pageSize: 100 }).then(res => {
          this.salesman = res.data.data.list
          this.salesman_id = ''
        })
        this.setSalesmanDialog = true
      }
    },
    handleVipGradeDelay(isSubmit = false) {
      if (isSubmit) {
        if (this.vipGradeDelay.filter == 'users' && this.vipGradeDelayUsers.length <= 0) {
          this.$message({
            type: 'error',
            message: '请选择需要延期的会员'
          })
          return
        }
        if (this.vipGradeDelay.add_day <= 0) {
          this.$message({
            type: 'error',
            message: '请输入正确的延期天数'
          })
          return
        }
        if (this.vipGradeDelay.filter == 'users') {
          this.vipGradeDelay.users = JSON.stringify(this.vipGradeDelayUsers)
        }
        batchReceiveMemberCard(this.vipGradeDelay).then(res => {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.vipGradeDialog = false
        })
      } else {
        if (this.vipGrade.length <= 0) {
          this.$message({
            type: 'error',
            message: '无付费会员'
          })
          return
        }
        this.vipGradeDialog = true
        this.vipGradeDelay.vip_grade_id = this.vipGrade[0].vip_grade_id
      }
    },
    checkNum() {
      if (this.sms_content.length > 67) {
        this.$alert('当前短信内容字数超出67，将会分成多条发送', '', {
          confirmButtonText: '确定'
        })
      }
    },
    onSmsSends() {
      var params = {

        mobile: this.smsUserData,
        content: this.sms_content
      }

      var num = this.smsUserData.length
      if (this.overall == 1) {
        num = this.total_count
        this.smsForm.where = this.params
        this.smsForm.overall = this.overall
      } else {
        this.smsForm.overall = 0
        this.smsForm.where = []
      }
      this.$confirm('确定发送该条短信给以上' + num + '人?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        memberSmsSend(this.smsForm).then(res => {
          this.smsSeedsDialog = false
          this.$message({
            type: 'success',
            message: '发送成功!'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消发送'
        })
      })
    },
    tagUpdate(row) {
      this.tag.editUser = [row.username]
      this.tag.currentTags = row.tagList
      this.tag.form.user_ids = row.user_id
      this.showTags()
    },
    addMemberTag() {
      this.tag.currentTags = []
      if (this.user_id.length) {
        this.showTags()
        this.tag.editUser = this.smsUserData
        this.tag.form.user_ids = this.user_id
      } else {
        this.$message({
          type: 'error',
          message: '请选择至少一个会员!'
        })
      }
    },
    showTags() {
      this.tag.tags = [...this.tag.list]
      this.tag.tags.forEach((item, index) => {
        let isInArr = this.tag.currentTags.findIndex((n) => n.tag_id == item.tag_id)
        if (isInArr != -1) this.tag.tags.splice(index, 1)
      })
      this.tag.dialog = true
    },
    tagRemove(index) {
      this.tag.tags.unshift(this.tag.currentTags[index])
      this.tag.currentTags.splice(index, 1)
    },
    tagAdd(item, index) {
      let isInArr = this.tag.currentTags.findIndex(n => n.tag_id == item.tag_id)
      if (isInArr == -1) {
        this.tag.currentTags.push(item)
        this.tag.tags.splice(index, 1)
      }
    },
    submitMemberTag() {
      this.tag.form.tag_ids = []
      this.tag.currentTags.forEach(item => {
        this.tag.form.tag_ids.push(item.tag_id)
      })
      this.tag.dialog = false
      usersRelTags(this.tag.form).then(res => {
        if (res.data.data.status) {
          this.$message({
            type: 'success',
            message: '打标签完成'
          })
        }
      })
    },

    tagSearchUserChange() {
      this.currentPage = 1
      this.getParams()
      this.getMembers(this.params)
      this.loading = false
    },
    getAllTagLists() {
      let params = {
        page: 1,
        page_size: 500
      }
      getTagList(params).then(response => {
        this.tag.list = response.data.data.list
      })
    },
    editMobile(row) {
      this.editMobileDialog = true
      this.form.oldMobile = row.mobile
      this.form.user_id = row.user_id
      this.form.username = row.username
      this.form.newMobile = ''
      this.getOperateLog(row.user_id)
    },
    onEditMobileSubmit() {
      if (!this.form.newMobile) {
        this.$message({
          type: 'error',
          message: '请填写手机号码'
        })
        return
      }
      this.$confirm('确定要修改该会员手机号？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            updateMemberMobile(this.form).then(res => {
              this.$message({
                type: 'success',
                message: '修改手机号成功'
              })
              this.getParams()
              this.getMembers(this.params)
              this.editMobileDialog = false
            })
          }
          done()
        }
      })
    },
    getOperateLog(userId) {
      var params = {
        user_id: userId
      }
      getMemberOperateLog(params).then(res => {
        this.operateLog = res.data.data.list
      })
    },
    storeHandle(param) {
      param && param.shop_id
      this.currentDistributor = param.shop_id
      this.currentShop = ''
      this.currentPage = 1
      this.getParams()
      this.getMembers(this.params)
    },
    init() { },
    getShopsList(filter) {
      this.loading = true
      filter.pageSize = 500
      getWxShopsList(filter).then(response => {
        this.wxShopsList = response.data.data.list
        this.loading = false
      })
    },
    shopHandle(val) {
      this.performInit = true
      this.currentStore = ''
      this.currentShop = val
      this.currentPage = 1
      this.getParams()
      this.getMembers(this.params)
    },
    getVipList() {
      listVipGrade().then(res => {
        this.vipGrade = res.data.data
      })
    },
    exportData() {
      this.currentPage = 1
      this.getParams()
      memberExport(this.params).then(response => {
        if (response.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表中下载'
          })
          return
        } else if (response.data.url) {
          this.downloadUrl = response.data.url
          this.downloadName = response.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return
        }
      })
    },
    dateChange(val) {
      if (val.length > 0) {
        this.params.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.time_start_begin = ''
        this.params.time_start_end = ''
      }
      this.params.page = 1
      this.getParams()
      this.getMembers(this.params)
    },
    dateStrToTimeStamp(str) {
      return Date.parse(new Date(str)) / 1000
    },
    panelCollapse(name) {
      this.panel[name] = !this.panel[name]
    },
    acitonDisabled(index, row) {
      if (row.is_disabled === true) {
        var msg = '此操作将会禁用该会员，是否继续?'
        this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            'user_id': row.user_id,
            'disabled': row.disabled
          }
          updateMemberInfo(params).then(res => {
            this.getParams()
            this.getMembers(this.params)
          })
        })
      } else {
        let params = {
          'user_id': row.user_id,
          'disabled': row.disabled
        }
        updateMemberInfo(params).then(res => {
          this.getParams()
          this.getMembers(this.params)
        })
      }
    },
    exportLogData(){
      this.exportdialogFormVisible=true;
  },
  exportLog(){
    this.$message({
        type: "success",
        message: "请稍后正在导出~",
      });
      advancelogExport(this.logform).then(res => {
          if (res.data.data.status) {
              var url = res.data.data.url
              window.open(url)
          } else {
              this.$notify({
                  title: '失败',
                  message: '出错了!',
                  type: 'error'
              })
          }
      })
  },
  },
  mounted() {
    if (store.getters.login_type === 'distributor') {
      this.is_distributor = true
    }
    if (this.$route.query.salesman_mobile) {
      this.salesman_mobile = this.$route.query.salesman_mobile
    }
    this.getParams()
    if (this.$route.query.mobile) {
      this.mobile = this.params.mobile = this.$route.query.mobile
    }
    if (this.$route.query.orderRecords) {
      this.order_records = this.params.have_consume = this.$route.query.orderRecords + ''
    }
    if (this.$route.query.grade_id) {
      this.params.grade_id = this.$route.query.grade_id
    }
    if (this.$route.query.currentPage) {
      this.params.page = Number(this.$route.query.currentPage)
    }
    this.getMembers(this.params)
    let param = {
      page: 1,
      pageSize: 100
    }
    this.getShopsList(param)
    this.getGradeList()
    this.getAllTagLists()
    this.getVipList()

  },
  watch: {
    // 分页全选-监听数据变化
    memberData: {
      handler(value) {
        if (this.allCheck) {

          this.memberData.forEach(row => {
            if (row) {
              this.$refs.multipleTable.toggleRowSelection(row, true)
            }
          });
        }
      },
      deep: true
    },
  }
}
</script>


<style scoped lang="scss">
.mobile-editor {
  cursor: pointer;
  font-size: 14px;
  margin-left: 5px;
}

.tag-users {
  padding-bottom: 10px;
  line-height: 1.2;

  .icon-user-circle1 {
    margin-right: 10px;
    font-size: 24px;
    color: #ccc;
  }
}

.selected-tags {
  padding-top: 15px;
  margin-bottom: 15px;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;

  .label {
    margin-bottom: 15px;
  }

  .el-tag {
    margin-right: 10px;
    margin-bottom: 15px;
  }
}

.tag-item {
  cursor: pointer;
  color: #666;
  border-color: #dadadd;
  margin-right: 10px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// list.vue?4c115d56